import { registerWindow , openWindow } from './common.js';

export default class Mobile{
    start(){
        const windows_toggler = document.querySelectorAll( '._js-mobile-window-toggler' );
        windows_toggler.forEach( item => this.setWindow( item ) );
    }

    setWindow( item ){
        if( item.dataset.window ){
            let win = document.querySelector( item.dataset.window );
            if( win ){

                let close_btn = win.querySelector( '.mobile-window__close' );

                if( close_btn ){

                    registerWindow( win , 'mobile-window_active' , 'mobile-window_inactive' );

                    item.addEventListener(
                        'click' ,
                        ( e ) => {
                            if( win.classList.contains( 'mobile-window_inactive' ) ){
                                openWindow( win );
                            }else{
                                openWindow()
                            }
                            e.stopPropagation();
                        }
                    );

                    close_btn.addEventListener(
                        'click' ,
                        ( e ) => {
                            openWindow();
                            e.stopPropagation();
                        }
                    );
                }
            }
        }
    }
}
